module.exports = __webpack_public_path__ + "img/43c55bb.png";